import { createSelector } from '@ngrx/store';
import { NotificationsState } from '../reducers/notifications.reducer';


const selectFeature = (state: any) => state.notifications;


export const selectNotification = createSelector(
    selectFeature,
    (state: NotificationsState) => state.notifications?.notifications?.notifications
);


export const selectNotificationAuthorizations = createSelector(
    selectFeature,
    (state: NotificationsState) => state.notificationsAuthorizations?.notifications?.notifications
);

export const selectNotificationDetail = createSelector(
    selectFeature,
    (state: NotificationsState) => state.notificationDetail
);

export const selectUnreadCount = createSelector(
    selectFeature,
    (state: NotificationsState) => state.unreadCount ?? 0
);

export const selectNotificationAuthorizationsLoading = createSelector(
    selectFeature,
    (state: NotificationsState) => state.notificationsAuthorizations?.isLoading
);
